module.exports = __webpack_public_path__ + "static/media/microBlog.232a1478.png";